module.exports = __webpack_public_path__ + "static/marlos_urnrayle_with_ironfang-b0b56ddd33e0698c1374034e42d7feb9.jpeg";